import { combineReducers } from 'redux';
import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { alert } from './alert.reducer';
import { submenu } from './submenu.reducer';
import { sidebarShow } from './sidebar.show';
import { appconfg } from './appconfig.reducer';
import { cart } from './cart.reducer';
import { services } from './service.reducer';
import { DirectMessaging } from './direct-messaging.reducer';
const rootReducer = combineReducers({
  authentication,
  registration,
  services,
  alert,
  submenu,
  sidebarShow,
  appconfg,
  cart,
  DirectMessaging
});

export default rootReducer;